import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type OnboardingStep = 'onboarding' | 'complete';

interface BusinessData {
  companyName: string;
  sector: string;
  registrationNumber: string;
}

export interface OnboardingState {
  currentStep: OnboardingStep;
  userId: string | null;
  completedUsers: string[];
  business: BusinessData | null;
  selfName: string | null;
  selfLinkedIn: string | null;
  voiceAnswers: Record<string, string>;
  setBusiness: (data: BusinessData) => void;
  setSelfIdentity: (name: string, linkedIn: string) => void;
  setVoiceAnswer: (questionId: string, answer: string) => void;
  complete: (userId: string) => void;
  reset: () => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      currentStep: 'onboarding',
      userId: null,
      completedUsers: [],
      business: null,
      selfName: null,
      selfLinkedIn: null,
      voiceAnswers: {},
      setBusiness: (data) => set({ business: data }),
      setSelfIdentity: (name, linkedIn) => set({ selfName: name, selfLinkedIn: linkedIn }),
      setVoiceAnswer: (questionId, answer) =>
        set((state) => ({ voiceAnswers: { ...state.voiceAnswers, [questionId]: answer } })),
      complete: (userId) =>
        set((state) => ({
          currentStep: 'complete',
          userId,
          completedUsers: state.completedUsers.includes(userId)
            ? state.completedUsers
            : [...state.completedUsers, userId],
        })),
      reset: () =>
        set({
          currentStep: 'onboarding',
          userId: null,
          business: null,
          selfName: null,
          selfLinkedIn: null,
          voiceAnswers: {},
        }),
    }),
    { name: 'assay-onboarding' }
  )
);
